import RoleFormPage from '../RoleFormPage/RoleFormPage'

export default function RoleCreatePage() {
  return <RoleFormPage mode="create" />
}
